/**
 * Extract plain text from HTML content
 * Removes all HTML tags and decodes HTML entities
 * @param {string} html - HTML content
 * @returns {string} Plain text without HTML tags
 */
export const stripHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  
  // Create a temporary div element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  
  // Get text content (automatically strips HTML tags)
  let text = tempDiv.textContent || tempDiv.innerText || '';
  
  // Clean up extra whitespace
  text = text.replace(/\s+/g, ' ').trim();
  
  return text;
};

/**
 * Get excerpt from HTML content
 * @param {string} html - HTML content
 * @param {number} maxLength - Maximum length of excerpt
 * @returns {string} Excerpt text
 */
export const getExcerpt = (html, maxLength = 150) => {
  const text = stripHtml(html);
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

